import { authHeader } from '../_helpers'
import httpClient from '../utils/http'
import _ from 'lodash'
import dates from 'react-big-calendar/lib/utils/dates'
import moment from 'moment'
import { message } from 'antd'
import { viewConstants } from '../_constants/view.constants'

moment.locale('en-nz')

// const empPdfReport = (userId, data) => {
//     const url = `/api/report/get-pdf/${userId}`

//     return httpClient
//         .post(url, data)
//         .then(handleResponseAsync)
//         .then(res => {
//             return res.arrayBuffer().then(res => {
//                 const pdfBlob = new Blob([res], { type: 'application/pdf' })
//                 const fileURL = URL.createObjectURL(pdfBlob)
//                 window.open(fileURL)
//             })
//         })
//         .catch(ex => {
//             message.error('')
//         })
// }

const fetchPdfReportData = async data => {
    const url = '/api/report/roster-report/etime/pdf'

    try {
        const reportData = await httpClient.post(url, data, {
            responseType: 'blob',
        })
        
        // Create a blob from the PDF data
        const pdfBlob = new Blob([reportData.data], { type: 'application/pdf' })
        
        // Create a link element
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(pdfBlob)
        
        // Set filename for download
        const fileName = `report_${new Date().getTime()}.pdf`
        link.download = fileName
        
        // Append to document, click, and cleanup
        document.body.appendChild(link)
        link.click()
        
        // Cleanup
        document.body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
        
        return reportData
    } catch (err) {
        message.error('Report error, please try again later')
    }
}

const fetchExcelReportData = async data => {
    const url = '/api/report/roster-report/etime/excel'

    try {
        const reportData = await httpClient.post(url, data, {
            responseType: 'blob',
        })
        return reportData
    } catch (err) {
        message.error('Report error, please try again later')
    }
}

const updateSummaryReportEvents = async options => {
    const leave_url = '/api/leave'

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = Object.assign({}, defaultQueryCond, options)

    try {
        // get employee leave
        const leaves = await httpClient.post(leave_url, queryCond)

        // get employee roster
        const roster_url = '/api/etime/preview'

        const rostersResponse = await httpClient.post(roster_url, queryCond)
        
        // Convert preview format to expected format for transformSummaryEvents
        const convertedRosters = convertRosterListForReport(rostersResponse.data.data)

        const graphEvents = transformSummaryEvents(
            convertedRosters,
            leaves.data.data,
            queryCond
        )

        return graphEvents
    } catch (err) {
        message.error('Report error, please try again later')
    }
}

/**
 *  transform events to graph data
 * @param {}} events
 */
function transformSummaryEvents(roster, leave, options) {
    const _workColor = 'hsl(215, 70%, 50%)'
    const _absenceColor = 'hsl(216, 70%, 50%)'

    const graphEvents = []
    const { time, range } = options

    const start = moment(time).startOf(range)
    const end = moment(time).endOf(range)

    const displayRange = dates.range(start, end)

    displayRange.map((date, j) => {
        const dateRosterEvents = _.filter(roster, function(evt) {
            const startOfDay = moment(date).startOf('day')

            const endOfDay = moment(date).endOf('day')

            return inRangeTest(
                moment(evt.PayrollEmpRosterStartDate).toDate(),
                moment(evt.PayrollEmpRosterEndDate).toDate(),
                startOfDay.toDate(),
                endOfDay.toDate()
            )
        })

        const dailyRosterSummary = dateRosterEvents.length

        const dateLeaveEvents = _.filter(leave, function(evt) {
            const startOfDay = moment(date).startOf('day')

            const endOfDay = moment(date).endOf('day')

            return inRangeTest(
                moment(evt.PayrollEmpRosterStartDate).toDate(),
                moment(evt.PayrollEmpRosterEndDate).toDate(),
                startOfDay.toDate(),
                endOfDay.toDate()
            )
        })

        const dailyLeaveSummary = dateLeaveEvents.length

        const dateLabel = moment(date).format('DD')

        graphEvents.push({
            date: dateLabel,
            work: dailyRosterSummary,
            workColor: _workColor,
            leave: dailyLeaveSummary,
            absenceColor: _absenceColor,
        })
    })

    return graphEvents
}

function inRangeTest(start, end, timeSlotStart, timeSlotEnd) {
    if (dates.lt(start, timeSlotStart)) {
        if (dates.lte(end, timeSlotStart)) {
            return false
        } else {
            return true
        }
    } else if (dates.gte(start, timeSlotEnd)) {
        return false
    } else {
        return true
    }
}

function convertViewModelListLeave(data) {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            const m = {}
            m.id = o.PayrollEmpLeaveAutoID
            m.start = moment(o.PayrollEmpLeaveDate).toDate()
            m.end = moment(o.PayrollEmpLeaveEndDate).toDate()
            m.EmployeeID = o.PayrollEmpLeaveEmployeeID
            m.Title = o.title
            viewModel.push(m)
        })
    }

    return viewModel
}

const convertViewModelListRoster = data => {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            const m = {}
            m.id = o.PayrollEmpRosterAutoID
            m.Title = o.PayrollEmpRosterDispTitle
            m.Note = o.PayrollEmpRosterActionNotes
            m.Break = o.PayrollEmpRosterBreakMinute
            m.start = moment(o.PayrollEmpRosterStartDate).toDate()
            m.end = moment(o.PayrollEmpRosterEndDate).toDate()
            m.EmployeeID = o.PayrollEmpRosterEmployeeID
            m.ActionType = o.PayrollEmpRosterActionTypeID
            m.Status = o.PayrollEmpRosterStatus
            m.CompanyId = o.PayrollEmpRosterCompanyID
            m.draggable = o.PayrollEmpRosterStatus !== 'approved' ? true : false
            m.source = o.source
            m.hours = o.PayrollEmpRosterHours

            m.Employee = o.Employee

            if (o.PayrollEmpRosterActionTypeID < 99) {
                m.allDay = true
            }
            viewModel.push(m)
        })
    }

    return viewModel
}

// Convert preview API response to PayrollEmpRoster format for report transforms
function convertRosterListForReport(data) {
    if (!_.isArray(data)) return data
    
    return data.map(o => {
        const converted = {}
        
        converted.PayrollEmpRosterAutoID = o.RosterAutoID
        converted.PayrollEmpRosterEmployeeID = o.RosterEmployeeID
        converted.PayrollEmpRosterCompanyID = o.RosterCompanyID
        
        // Use full ISODateTime if available, else construct from date+time
        if (o.startTime) {
            converted.PayrollEmpRosterStartDate = o.startTime
            converted.PayrollEmpRosterEndDate = o.endTime
        } else {
            converted.PayrollEmpRosterStartDate = constructDateTime(o.RosterDate, o.RosterStartTimeHour, o.RosterStartTimeMinute)
            converted.PayrollEmpRosterEndDate = constructDateTime(o.RosterEndDate || o.RosterDate, o.RosterFinishTimeHour, o.RosterFinishTimeMinute)
        }
        
        converted.PayrollEmpRosterStartTimeHour = o.RosterStartTimeHour
        converted.PayrollEmpRosterStartTimeMinute = o.RosterStartTimeMinute
        converted.PayrollEmpRosterFinishTimeHour = o.RosterFinishTimeHour
        converted.PayrollEmpRosterFinishTimeMinute = o.RosterFinishTimeMinute
        
        converted.PayrollEmpRosterDispTitle = o.RosterDispTitle || generateTitle(o)
        converted.PayrollEmpRosterActionNotes = o.RosterNotes
        converted.PayrollEmpRosterBreakMinute = o.RosterBreakMinute || 0
        converted.PayrollEmpRosterActionTypeID = o.RosterActionTypeID !== undefined ? o.RosterActionTypeID : 0
        converted.PayrollEmpRosterStatus = o.RosterApproved !== undefined ? (o.RosterApproved ? 'approved' : 'draft') : 'draft'
        converted.PayrollEmpRosterHours = o.RosterHours
        converted.PayrollEmpRosterWorkPlanID = o.RosterWorkPlanID
        converted.PayrollEmpRosterOriginalRosterID = o.RosterOriginalRosterID
        converted.PayrollEmpRosterLocation1ID = o.RosterLocation1ID
        converted.PayrollEmpRosterLocation2ID = o.RosterLocation2ID
        converted.PayrollEmpRosterLocation3ID = o.RosterLocation3ID
        converted.PayrollEmpRosterLocation4ID = o.RosterLocation4ID
        converted.PayrollEmpRosterLocation5ID = o.RosterLocation5ID
        converted.PayrollEmpRosterTaskID = o.RosterTaskID
        
        if (o.Employee) {
            converted.Employee = o.Employee
        }
        
        return converted
    })
}

function generateTitle(o) {
    if (o.startTime && o.endTime) {
        return `${moment(o.startTime).format('HH:mm')} - ${moment(o.endTime).format('HH:mm')}`
    }
    if (o.RosterDate && o.RosterStartTimeHour !== undefined && o.RosterFinishTimeHour !== undefined) {
        const start = moment(o.RosterDate).hour(o.RosterStartTimeHour).minute(o.RosterStartTimeMinute || 0)
        const end = moment(o.RosterDate).hour(o.RosterFinishTimeHour).minute(o.RosterFinishTimeMinute || 0)
        return `${start.format('HH:mm')} - ${end.format('HH:mm')}`
    }
    return 'Shift'
}

function constructDateTime(date, hour, minute) {
    if (!date && hour === undefined) return null
    const m = moment(date)
    if (hour !== undefined) m.hour(hour)
    if (minute !== undefined) m.minute(minute)
    return m.toISOString()
}

export const reportService = {
    updateSummaryReportEvents,
    fetchPdfReportData,
    fetchExcelReportData,
}
